import { CloseCircleFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { ErrorColor } from "styles/buildertrendTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconCloseCircleError: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return (
        <CloseCircleFilled
            {...props}
            type="close-circle"
            style={{ ...props.style, color: ErrorColor }}
        />
    );
};
